// FOR STAFF
export const VIEW_TASK_REQUEST = "VIEW_TASK_REQUEST";
export const VIEW_TASK_SUCCESS = "VIEW_TASK_SUCCESS";
export const VIEW_TASK_FAIL = "VIEW_TASK_FAIL";
export const VIEW_TASK_RESET = "VIEW_TASK_RESET";

export const SINGLE_TASK_REQUEST = "SINGLE_TASK_REQUEST";
export const SINGLE_TASK_SUCCESS = "SINGLE_TASK_SUCCESS";
export const SINGLE_TASK_FAIL = "SINGLE_TASK_FAIL";

export const CREATE_TASK_REQUEST = "CREATE_TASK_REQUEST";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const CREATE_TASK_FAIL = "CREATE_TASK_FAIL";
export const CREATE_TASK_RESET = "CREATE_TASK_RESET";

export const UPDATE_TASK_REQUEST = "UPDATE_TASK_REQUEST";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAIL = "UPDATE_TASK_FAIL";
export const UPDATE_TASK_RESET = "UPDATE_TASK_RESET";

export const DELETE_TASK_REQUEST = "DELETE_TASK_REQUEST";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const DELETE_TASK_FAIL = "DELETE_TASK_FAIL";
export const DELETE_TASK_RESET = "DELETE_TASK_RESET";

export const ASSIGN_TASK_REQUEST = "ASSIGN_TASK_REQUEST";
export const ASSIGN_TASK_SUCCESS = "ASSIGN_TASK_SUCCESS";
export const ASSIGN_TASK_FAIL = "ASSIGN_TASK_FAIL";
export const ASSIGN_TASK_RESET = "ASSIGN_TASK_RESET";

export const DISPLAY_SUBMISSION_REQUEST = "DISPLAY_SUBMISSION_REQUEST";
export const DISPLAY_SUBMISSION_SUCCESS = "DISPLAY_SUBMISSION_SUCCESS";
export const DISPLAY_SUBMISSION_FAIL = "DISPLAY_SUBMISSION_FAIL";

export const GRADE_TASK_REQUEST = "GRADE_TASK_REQUEST";
export const GRADE_TASK_SUCCESS = "GRADE_TASK_SUCCESS";
export const GRADE_TASK_FAIL = "GRADE_TASK_FAIL";
export const GRADE_TASK_RESET = "GRADE_TASK_RESET";

// FOR STUDENT
export const VIEW_ASSIGNMENT_REQUEST = "VIEW_ASSIGNMENT_REQUEST";
export const VIEW_ASSIGNMENT_SUCCESS = "VIEW_ASSIGNMENT_SUCCESS";
export const VIEW_ASSIGNMENT_FAIL = "VIEW_ASSIGNMENT_FAIL";
export const VIEW_ASSIGNMENT_RESET = "VIEW_ASSIGNMENT_RESET";

export const SINGLE_ASSIGNMENT_REQUEST = "SINGLE_ASSIGNMENT_REQUEST";
export const SINGLE_ASSIGNMENT_SUCCESS = "SINGLE_ASSIGNMENT_SUCCESS";
export const SINGLE_ASSIGNMENT_FAIL = "SINGLE_ASSIGNMENT_FAIL";

export const SUBMIT_ASSIGNMENT_REQUEST = "SUBMIT_ASSIGNMENT_REQUEST";
export const SUBMIT_ASSIGNMENT_SUCCESS = "SUBMIT_ASSIGNMENT_SUCCESS";
export const SUBMIT_ASSIGNMENT_FAIL = "SUBMIT_ASSIGNMENT_FAIL";
export const SUBMIT_ASSIGNMENT_RESET = "SUBMIT_ASSIGNMENT_RESET";
